import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  Stack,
  Flex,
  Spinner,
} from "@chakra-ui/core";

import { MdKeyboardArrowDown } from "react-icons/md";

import SearchBox from "../elements/SearchBox";
import { useCustomers } from "../../hooks/customer";
import ActionList from "./ActionList";

const CustomersGrid = ({ retrievedCustomers, refetch }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchString, setSearchString, matches] = useCustomers();

  /**
   * filters out searched items
   *
   * @param {*} retrievedCustomers
   * @param {*} matches
   * @returns
   */
  const processedData = (retrievedCustomers, matches) => {
    let sortData = [];
    retrievedCustomers.map((customer) => {
      return matches.forEach((match) => {
        if (
          customer.firstName === match.firstName ||
          customer.phone === match.phone
        ) {
          sortData.push({
            ...customer,
            searched: true,
          });
        }
      });
    });
    if (matches.length > 0) {
      return sortData
        .filter((item) => item.searched === true)
        .sort((a, b) => b.createdAt - a.createdAt);
    }
    return retrievedCustomers;
  };

  useEffect(() => setCustomers(processedData(retrievedCustomers, matches)), [
    retrievedCustomers,
    matches,
  ]);

  useEffect(() => {
    if (retrievedCustomers) {
      setCustomers(retrievedCustomers);

      setLoading(false);
    }
  }, [retrievedCustomers]);

  if (loading) {
    return (
      <Flex alignItems="center" height="50vh" justifyContent="center">
        <Spinner />
      </Flex>
    );
  }

  return (
    <>
      {/** Grid Search box */}
      <SearchBox
        entity="Customers"
        searchString={searchString}
        setSearchString={setSearchString}
        matches={matches}
        widget={false}
      />
      {/** Grid header/filter */}
      {customers.length === 0 && !loading ? (
        <Flex align="center" justify="center" marginY="1rem">
          <Text fontSize="1rem" fontWeight="bold">
            No customer found
          </Text>
        </Flex>
      ) : (
        <>
          <SimpleGrid
            columns={3}
            spacing={0}
            color="primary.400"
            fontSize={["xs", "sm", "sm", "sm"]}
          >
            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Stack isInline alignItems="flex-end">
                <Heading as="h6" size="sm">
                  Name
                </Heading>
                <Box as={MdKeyboardArrowDown} />
              </Stack>
            </Box>

            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Stack isInline alignItems="flex-end">
                <Heading as="h6" size="sm">
                  Contact details
                </Heading>
                <Box as={MdKeyboardArrowDown} />
              </Stack>
            </Box>
            {/* <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Heading as="h6" size="xs">
                Phone
              </Heading>
            </Box> */}
            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Heading as="h6" size="sm">
                Actions
              </Heading>
            </Box>            
          </SimpleGrid>
          <Box
            borderLeftWidth="1px"
            borderRightWidth="1px"
            borderColor="primary.100"
          >
            {/** Grid with all data */}
            <SimpleGrid
              columns={3}
              spacing={0}
              color="primary.400"
              fontSize={["xs", "sm", "sm", "sm"]}
            >
              {customers.map((customer, index) => {
                const { firstName, lastName, id, email, phone } = customer;
                return (
                  <React.Fragment key={id}>
                    <Box bg={index % 2 !== 0 ? "#fafafa" : "none"} p="12px" height="auto">
                      <Text fontSize="md" fontWeight="bold">{`${firstName} ${lastName}`}</Text>
                    </Box>
                    <Box bg={index % 2 !== 0 ? "#fafafa" : "none"} p="12px" height="auto">
                      {!email ? "-" : email}
                      <br/>
                      {phone}
                    </Box>
                    {/* <Box bg={index % 2 !== 0 ? "#fafafa" : "none"} p="12px" height="auto">
                      {phone}
                    </Box> */}
                    <Box bg={index % 2 !== 0 ? "#fafafa" : "none"} p="12px" height="auto">
                    <Stack isInline>
                      <ActionList refetch={refetch} order={{customer}} currentSection="customers"  />
                    </Stack>
                    </Box>                    
                  </React.Fragment>
                );
              })}
            </SimpleGrid>
          </Box>
        </>
      )}
    </>
  );
};

export default CustomersGrid;
